import React, {useState} from 'react'
import {Button, Modal} from 'react-bootstrap';
import { SansabotsCountdown } from './SansabotsCountdown';
import "../styles/components/sansabotsmodal.css";

export const SansabotsModal = () => {
  const [show, setShow] = useState(true);

  const handleClose = () => {
		setShow(false);
	};

  return (
    <Modal show={show} onHide={handleClose} dialogClassName="my-modal">
      <Modal.Header>
        <Modal.Title></Modal.Title>
        <Button className="fablab-button" onClick={handleClose}>
        Cerrar mensaje
        </Button>
      </Modal.Header>
      <Modal.Body>
        <SansabotsCountdown/>
      </Modal.Body>
      <Modal.Footer>
      </Modal.Footer>
    </Modal>
  )
}
